module.exports = __webpack_public_path__ + "static/media/p01_2x.68a71e49.png";